import { selectKrcCurriculumDomainNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const KRC_CURRICULUM_DOMAIN: BuildingBlockNodeConfig = {
  nodeSelector: selectKrcCurriculumDomainNode,
  information: {
    single: 'Domein',
    plural: 'Domeinen',
  },
  buildingBlocks: [{ type: NodeType.KRC_CURRICULUM_SUBDOMAIN }],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default KRC_CURRICULUM_DOMAIN;
